import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import SalemanForm from "@components/forms/SalemanForm";
import styles from "./style.module.scss";

const SalesmanAddEdit = () => {
  const params = useParams()
  const { id: salemanId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!salemanId ? 'Agregar' : 'Editar'} Vendedor`}
      backUrl="/user/salemen"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "salemanForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <SalemanForm
        formId="salemanForm"
        id={salemanId}
        saveRedirectUrl="/user/salemen"
      ></SalemanForm>

    </PageContainer>
  );
}

export default SalesmanAddEdit;
